module.exports = __webpack_public_path__ + "static/media/taggis-logo.78fc2eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/taggis-logo.svg
// module id = 273
// module chunks = 3